import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import ItineraryService from "../../../../services/catalogs/ItineraryService";

export const REQUEST_UPDATE_ITINERARY = "REQUEST_UPDATE_ITINERARY";
export const UPDATE_ITINERARY_SUCCESS = "UPDATE_ITINERARY_SUCCESS";
export const UPDATE_ITINERARY_ERROR = "UPDATE_ITINERARY_ERROR";

function requestUpdateItinerary() {
  return {
    type: REQUEST_UPDATE_ITINERARY,
  };
}

function updateItinerarySuccess(json) {
  return {
    type: UPDATE_ITINERARY_SUCCESS,
    message: json.data,
  };
}

function updateItineraryError(json) {
  return {
    type: UPDATE_ITINERARY_ERROR,
    error: json.data,
  };
}

export function updateItinerary(itinerary_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateItinerary());
    return ItineraryService.putItinerary(itinerary_id, payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateItinerarySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateItinerary(itinerary_id, payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(updateItineraryError(json.data));
      }
    });
  };
}
